import { FinanceAccountLoadingContainer } from '../../../containers';

export const FinanceAccountLoading = () => {
  return <FinanceAccountLoadingContainer />;
};
